import Ajax from "Utils/ajax";
export const addHoliday = (data) => Ajax.post('hr/addHoliday',data);
export const holidayList = (data) => Ajax.post('hr/holidayList',data); 
export const removeHoliday = (data) => Ajax.post('hr/removeHoliday',data); 